"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositeFontInfo = void 0;
var enums_1 = require("./enums");
var CompositeFontInfo = (function () {
    function CompositeFontInfo() {
        this.asciiFontName = "";
        this.hightAnsiFontName = "";
        this.complexScriptFontName = "";
        this.eastAsiaFontName = "";
        this.asciiThemeFont = enums_1.ThemeFontType.None;
        this.hightAnsiThemeFont = enums_1.ThemeFontType.None;
        this.complexScriptThemeFont = enums_1.ThemeFontType.None;
        this.eastAsiaThemeFont = enums_1.ThemeFontType.None;
        this.hintFont = enums_1.FontTypeHint.Default;
    }
    CompositeFontInfo.prototype.equals = function (obj) {
        return obj &&
            this.asciiFontName == this.asciiFontName &&
            this.hightAnsiFontName == this.hightAnsiFontName &&
            this.complexScriptFontName == this.complexScriptFontName &&
            this.eastAsiaFontName == this.eastAsiaFontName &&
            this.asciiThemeFont == this.asciiThemeFont &&
            this.hightAnsiThemeFont == this.hightAnsiThemeFont &&
            this.complexScriptThemeFont == this.complexScriptThemeFont &&
            this.eastAsiaThemeFont == this.eastAsiaThemeFont &&
            this.hintFont == this.hintFont;
    };
    CompositeFontInfo.prototype.clone = function () {
        var result = new CompositeFontInfo();
        result.asciiFontName = this.asciiFontName;
        result.hightAnsiFontName = this.hightAnsiFontName;
        result.complexScriptFontName = this.complexScriptFontName;
        result.eastAsiaFontName = this.eastAsiaFontName;
        result.asciiThemeFont = this.asciiThemeFont;
        result.hightAnsiThemeFont = this.hightAnsiThemeFont;
        result.complexScriptThemeFont = this.complexScriptThemeFont;
        result.eastAsiaThemeFont = this.eastAsiaThemeFont;
        result.hintFont = this.hintFont;
        return result;
    };
    return CompositeFontInfo;
}());
exports.CompositeFontInfo = CompositeFontInfo;
